<template>
  <div class="adminList">
    <base-header class="pb-6">
      <div class="row align-items-center py-4" :class="{ blur: inviteID !== '' }">
        <div class="col-lg-6 col-7">
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>

    <b-form-group
      v-if="inviteID !== ''"
      :style="{
        backgroundColor: '#fff',
        border: '2px solid #e9ecef',
        padding: '2vw',
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: '9999',
      }"
      role="group"
      class="mb-3 has-feedback">
      <label class="w-100 form-control-label" for="channel.access_code"
        ><i class="fas fa-shield-alt"></i>
        Invitation Url
        <small>(Copy/Paste to Invite Followers)</small></label
      >
      <div class="pull-left w-75 strong">
        <br />
        <input id="inviteCode" type="hidden" :value="`${voboFrontendURL}/${selectedCompany}/${inviteID}?oa`" />
        <span class="inviUrl" @click.stop.prevent="copyLink"
          ><strong>{{ `${voboFrontendURL}/${selectedCompany}/${inviteID}?oa` }}</strong></span
        >
        <a class="btn btn-primary text-white copy-btn" @click.stop.prevent="copyLink('inviteCode')"> <i class="far fa-copy"></i> Copy to Clipboard </a>
      </div>
      <vue-qrious class="pull-right" :value="`${voboFrontendURL}/${selectedCompany}/${inviteID}?oa`" />
    </b-form-group>

    <div class="container-fluid mt--6" :class="{ blur: inviteID !== '' }" @click="closeInviteModal">
      <card no-body body-classes="px-0 pb-1" footer-classes="pb-2">
        <div slot="header" class="row align-items-center">
          <div class="col-lg-6 col-6">
            <h3 class="mb-0">Content Providers</h3>
          </div>

          <div class="col-lg-6 col-6 no-gutter-left pull-right">
            <button class="btn btn-vobo opacity-8 pull-right" @click="openCPForm">
              <i class="fa fa-plus-circle"></i>
              Add Content Provider
            </button>

            <b-dropdown v-if="totalRows > 0 && !loading" id="fieldsFilter" dropleft size="md" variant="success" class="pull-right mr-2">
              <template #button-content> <i class="fas fa-file-csv"></i> Download CSV </template>
              <li>
                <span v-if="searchRequest || selectedStatus !== 'all'" class="text-default"
                  >TOTAL FILTERED USERS (<strong class="text-default">{{ totalRows }}</strong
                  >)</span
                >
                <span v-else class="text-default"
                  >TOTAL ACTIVE USERS (<strong class="text-default">{{ totalActiveRows }}</strong
                  >)</span
                >
                <b-form-group label="Fields Filters" class="mb-0">
                  <b-form-checkbox-group id="checkbox-group-2" v-model="selectedFieldsFilterCheck" name="flavour-2">
                    <b-form-checkbox v-for="(item, index) in fieldsFilter" :key="index" :value="item.value" @change="updateFilteredFields(item.value)">{{
                      item.text
                    }}</b-form-checkbox>
                  </b-form-checkbox-group>
                  <div class="row mt-4 px-0 mx-0 w-100 col-lg-12 col-md-12 col-12 pull-left">
                    <div class="col-lg-12 col-md-12 col-12 no-gutters">
                      <download-csv
                        v-if="selectedFieldsFilterCheck.length > 0"
                        class="downloadCSVButton btn btn-vobo float-right w-sm-100 mb-3 mb-md-0 downloadCSV"
                        :data="filteredCSVData"
                        name="channels.csv">
                        Download
                      </download-csv>
                    </div>
                  </div>
                </b-form-group>
              </li>
            </b-dropdown>
          </div>
        </div>

        <b-row>
          <div class="col-lg-12 col-md-12 col-12">
            <b-card no-body>
              <b-card-body>
                <b-row>
                  <div class="col-lg-12 col-md-12 col-12">
                    <div class="float-left d-flex align-items-center col-lg-3 no-gutters">
                      <div class="mr-3 text-nowrap">CP Status</div>
                      <b-form-select v-model="selectedStatus" :options="statuses" name="Filter" class="float-right" />
                    </div>

                    <div class="col-lg-3 pull-right no-gutters">
                      <base-input v-model="searchRequest" prepend-icon="fas fa-search" placeholder="Search"> </base-input>
                    </div>
                  </div>
                </b-row>
                <b-row v-if="loading">
                  <div class="col-lg-12 text-center">
                    <pulse-loader :color="'#3867d6'"></pulse-loader>
                  </div>
                </b-row>

                <b-table
                  v-if="!loading"
                  id="cpTable"
                  v-model:sort-by="sortBy"
                  v-model:sort-desc="sortDesc"
                  class="cpTable"
                  responsive
                  hover
                  :items="contentProviderList"
                  :fields="ListFields"
                  :filter="searchRequest"
                  :current-page="currentPage"
                  :per-page="perPage"
                  head-variant="light"
                  @filtered="onSearch">
                  <div slot="clientName" slot-scope="item" class="data">
                    <div class="col-lg-2 rounded-circle pull-left no-gutters">
                      <img :id="`${item.item.cpID}`" :src="item.item.image" width="100%" />
                      <b-popover :target="`${item.item.cpID}`" placement="right" triggers="hover" style="text-align: center">
                        <template #title style="background: #fff">Image</template>
                        <img :src="item.item.image" width="100%" />
                      </b-popover>
                    </div>
                    <div class="col-lg-10 pull-left no-gutter-right">
                      <span class="title text-break-all text-sm-custom">{{ item.item.clientName }}</span>
                    </div>
                  </div>
                  <div slot="contactName" slot-scope="item" class="data">
                    <span class="title text-break-all">{{ item.item.contactName }}</span>
                  </div>
                  <div slot="email" slot-scope="item" class="data">
                    <span class="title text-break-all">{{ item.item.email }}</span>
                  </div>
                  <div slot="image" slot-scope="item" class="data text-center">
                    <div>
                      <img :id="`${item.item.cpID}`" :src="item.item.image" width="20%" />
                    </div>
                    <b-popover :target="`${item.item.cpID}`" placement="right" triggers="hover" style="text-align: center">
                      <template #title style="background: #fff">Image</template>
                      <img :src="item.item.image" width="100%" />
                    </b-popover>
                  </div>
                  <div slot="category" slot-scope="item" class="data">
                    <div v-if="item.item.category !== ''">
                      <span class="catgroup">CATEGORY</span>
                      <span class="title text-break-all">{{ item.item.category }}</span>
                    </div>
                    <div v-if="item.item.group !== ''">
                      <span class="catgroup">GROUP</span>
                      <span class="title text-break-all">{{ item.item.group }}</span>
                    </div>
                    <div v-if="item.item.group === '' && item.item.category === ''">
                      <span class="catgroup">GROUP</span>
                      <span class="title text-break-all">All</span>
                    </div>
                  </div>

                  <div slot="type" slot-scope="item" class="data">
                    <span class="title text-break-all">
                      <span
                        :class="{
                          'bg-success': item.item.type === 'PRIMARY',
                          'bg-danger': item.item.type === 'HYBRID',
                          'bg-vobo': item.item.type === 'SECONDARY',
                          'bg-default': item.item.type === 'DEFAULT',
                        }"
                        class="badge badge-pill text-white"
                        >{{ item.item.type }}</span
                      >
                      <span
                        v-if="item.item.isForceFollowing"
                        :class="{
                          'bg-warning': (item.item.type === 'SECONDARY' || item.item.type === 'HYBRID') && item.item.isForceFollowing,
                        }"
                        class="badge badge-pill text-white ffbadge"
                        >Force Following</span
                      >
                    </span>
                  </div>
                  <div slot="accessCode" slot-scope="item" class="data">
                    <span class="title text-break-all">{{ item.item.accessCode }}</span>
                  </div>
                  <div slot="status" slot-scope="item" class="data text-center">
                    <span class="title text-break-all">
                      <span :class="item.item.status.statusClass" class="badge badge-pill text-white">{{ item.item.status.status }}</span>
                    </span>
                  </div>
                  <div slot="actions" slot-scope="item" class="data data userBtn">
                    <div v-if="item.item.actions !== currentUserID">
                      <router-link
                        v-if="item.item.status.status === 'active'"
                        v-b-tooltip.hover
                        :to="cpEditLink(item.item.actions, searchRequest)"
                        title="Edit Content Provider"
                        class="btn btn-outline-primary btn-sm">
                        <span class="btn-inner--icon"><i class="far fa-edit"></i> </span>
                      </router-link>
                      <a
                        v-if="item.item.status.status === 'active'"
                        v-b-tooltip.hover
                        title="Delete Content Provider"
                        class="btn btn-outline-danger btn-sm text-danger"
                        @click="deleteProcess(item.item.actions, item.item)">
                        <span class="btn-inner--icon"><i class="far fa-trash-alt"></i> </span>
                      </a>
                      <router-link
                        v-if="item.item.status.status === 'active'"
                        v-b-tooltip.hover
                        :to="`/links/${item.item.actions}`"
                        title="Union Link"
                        class="btn btn-outline-success btn-sm text-success">
                        <span class="btn-inner--icon"><i class="fas fa-link"></i> </span>
                      </router-link>
                      <a
                        v-b-tooltip.hover
                        size="sm"
                        :title="!item.detailsShowing ? 'Show Details' : 'Hide Details'"
                        class="btn btn-outline-vobo btn-sm text-vobo"
                        @click="item.toggleDetails">
                        <span class="btn-inner--icon"
                          ><i
                            :class="{
                              'far fa-eye-slash': item.detailsShowing,
                              'far fa-eye': !item.detailsShowing,
                            }"></i>
                        </span>
                      </a>
                      <a
                        v-b-tooltip.hover
                        :title="item.item.status.status === 'active' ? 'Deactivate Content Provider' : 'Activate Content Provider'"
                        class="btn btn-outline-vobo btn-sm text-vobo"
                        @click="activateContentProvider(item.item.status.status, item.item.actions, item.item.userID)">
                        <span class="btn-inner--icon"><i :class="item.item.status.status === 'active' ? 'fas fa-toggle-on' : 'fas fa-toggle-off'"></i> </span>
                      </a>
                      <a
                        v-if="item.item.status.status === 'active'"
                        v-b-tooltip.hover
                        title="Reset Password"
                        class="btn btn-outline-primary btn-sm text-primary"
                        @click="resetPassword(item.item.userID)">
                        <span class="btn-inner--icon"><i class="fas fa-lock"></i> </span>
                      </a>
                      <router-link
                        v-if="item.item.status.status === 'active'"
                        v-b-tooltip.hover
                        :to="`/content-provider/pricing-panel/${item.item.actions}`"
                        title="Pricing Panel"
                        class="btn btn-outline-success btn-sm text-success">
                        <span class="btn-inner--icon"><i class="fas fa-dollar-sign"></i> </span>
                      </router-link>
                      <a
                        v-if="item.item.status.status === 'active'"
                        v-b-tooltip.hover
                        title="Create Replica Channel"
                        class="btn btn-outline-primary btn-sm text-primary"
                        @click="duplicateCp(item.item.userID, item.item.clientName)">
                        <span class="btn-inner--icon"><i class="fas fa-copy"></i> </span>
                      </a>
                      <a
                        v-if="item.item.status.status === 'active'"
                        v-b-tooltip.hover
                        title="Channel Invite"
                        class="btn btn-outline-primary btn-sm text-primary"
                        @click="channelInviteModal(item.item.inviteID)">
                        <span class="btn-inner--icon"><i class="fas fa-user-plus"></i> </span>
                      </a>
                    </div>
                  </div>

                  <template #row-details="item">
                    <b-card class="userInfoRow p-3 mb-0">
                      <a v-b-tooltip.hover class="mr-3 pull-right" title="Close" @click="item.toggleDetails"
                        ><i class="fas fa-times text-muted pull-right"></i
                      ></a>
                      <b-row class="mb-2 mt-3">
                        <b-col lg="6" md="6" sm="12">
                          <b-row class="mb-2">
                            <b-col lg="4" md="4" sm="4" class="text-sm-right"><b>Contact Name:</b></b-col>
                            <b-col lg="8" md="8" sm="8" class="text-sm-left">{{ item.item.contactName }}</b-col>
                          </b-row>
                        </b-col>
                        <b-col lg="6" md="6" sm="12">
                          <b-row class="mb-2">
                            <b-col lg="3" md="3" sm="3" class="text-sm-right"><b>Company Default:</b></b-col>
                            <b-col lg="9" md="9" sm="9" class="text-sm-left">{{ item.item.isCompanyDefault ? 'YES' : 'NO' }}</b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                      <b-row class="mb-2">
                        <b-col lg="6" md="6" sm="12">
                          <b-row class="mb-2">
                            <b-col lg="4" md="4" sm="4" class="text-sm-right"><b>Total Primary Followers:</b></b-col>
                            <b-col lg="8" md="8" sm="8" class="text-sm-left">{{ item.item.userCount }}</b-col>
                          </b-row>
                        </b-col>
                        <b-col lg="6" md="6" sm="12">
                          <b-row class="mb-2">
                            <b-col lg="3" md="3" sm="3" class="text-sm-right"><b>Total Secondary Followers:</b></b-col>
                            <b-col lg="9" md="9" sm="9" class="text-sm-left">{{ item.item.secondaryUserCount }}</b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                      <b-row class="mb-2">
                        <b-col lg="6" md="6" sm="12">
                          <b-row class="mb-2">
                            <b-col lg="4" md="4" sm="4" class="text-sm-right"><b>Total Force Followers:</b></b-col>
                            <b-col lg="8" md="8" sm="8" class="text-sm-left">{{ item.item.fcUserCount }}</b-col>
                          </b-row>
                        </b-col>
                        <b-col lg="6" md="6" sm="12">
                          <b-row class="mb-2">
                            <b-col lg="4" md="4" sm="4" class="text-sm-right"><b> </b></b-col>
                            <b-col lg="8" md="8" sm="8" class="text-sm-left"> </b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                    </b-card>
                  </template>
                </b-table>
                <b-row v-if="contentProviderList.length === 0 && !loading">
                  <b-col sm="12">
                    <h4 v-if="selectedCompany === undefined" class="card-heading text-center">Please Select Organization First</h4>
                    <h4 v-else class="card-heading text-center">No records found</h4>
                  </b-col>
                </b-row>
                <b-pagination
                  v-if="totalRows > perPage && !loading"
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  class="my-0"
                  align="center"
                  @change="updateCurrentPage" />
                <div v-if="totalRows > perPage && contentProviderList.length !== 0" class="float-right">
                  <div class="float-right d-flex align-items-center">
                    <div class="mr-3 text-nowrap">Per Page</div>
                    <b-form-select v-model="perPage" :options="pageOptions" />
                  </div>
                </div>
              </b-card-body>
            </b-card>
          </div>
        </b-row>
      </card>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import Cookies from 'js-cookie';
import moment from 'moment';
import showConfirmation from '@/utils/mixins/deleteNotify';
import JsonCSV from 'vue-json-csv';
import { getPricePlanList } from '../../api/request/pricePlans';
import { duplicateContentProvider } from '../../api/request/contentProvider';
import VueQrious from 'vue-qrious';
import { NotificationTypes, wrapNotification } from '@/utils/notification';
import { DuplicateCpAlert } from './DuplicateCPAlert';
Vue.use(Cookies);
Vue.component('DownloadCsv', JsonCSV);

export default {
  components: {
    VueQrious,
  },
  name: 'AdminList',
  mixins: [showConfirmation],
  data: function () {
    return {
      frontEndURL: process.env.VUE_APP_FRONTEND_URL,
      errorFields: [],
      searchRequest: '',
      currentPage: 1,
      pricePlanList: null,
      totalRows: 0,
      totalActiveRows: 0,
      perPage: 10,
      pageOptions: [10, 20, 50, 100],
      selectedFilter: 'all',
      selectedStatus: 'all',
      inviteID: '',
      statuses: [
        { value: 'all', text: 'All' },
        { value: 'active', text: 'Active' },
        { value: 'inactive', text: 'Inactive' },
      ],
      sortBy: 'dateCreated',
      sortDesc: true,
      contentProviderListFilter: [],
      ListFields: {
        clientName: {
          key: 'clientName',
          label: 'Client Name',
          sortable: true,
        },
        email: {
          key: 'email',
          label: 'email',
          sortable: true,
        },
        category: {
          key: 'category',
          label: 'Category',
          sortable: true,
        },
        type: {
          key: 'type',
          label: 'Type',
          sortable: true,
        },
        accessCode: {
          key: 'accessCode',
          label: 'Access code',
        },
        status: {
          key: 'status',
          label: 'status',
          sortable: true,
        },
        actions: {
          label: 'actions',
        },
      },
      updateAccess: false,
      selectedFieldsFilterCheck: [
        'clientName',
        'contactName',
        'email',
        'category',
        'group',
        'type',
        'accessCode',
        'usersCounts',
        'dateCreated',
        'sentSms',
        'accountId',
        'pricePlanName',
        'resellerCode',
        'partnerAccountNumber',
        'revenueCollectionMethod',
        'offAppTextCreditsUsedLastMonth',
        'offAppTextCreditsPurchasedLastMonth',
        'offAppTextCreditsUsedCurrentMonth',
        'secureVideoEnabled',
        'totalMessagesSentLastMonth',
        'maxAppUsers',
        'partnerAccountNumber',
        'monthlyCharge',
        'registeredUserCount',
        'adminLoginsMonth',
        'userLoginsMonth',
        'movConversionMs',
        'audioViewCount',
        'videoViewCount',
        'imageViewCount',
        'fileViewCount',
        'audioViewDataTransferOut',
        'videoViewDataTransferOut',
        'imageViewDataTransferOut',
        'fileViewDataTransferOut',
      ],
      selectedFieldsFilter: [],
      CSVData: [],
    };
  },
  computed: {
    filteredCSVData() {
      var filteredList = [];
      var channelList = this.CSVData;
      let data = this.pricePlanList;

      channelList.map((channel) => {
        const userFiltered = {};
        if (this.selectedFieldsFilterCheck.includes('clientName')) {
          userFiltered['Client Name'] = channel.clientName;
        }

        if (this.selectedFieldsFilterCheck.includes('contactName')) {
          userFiltered['Full Name'] = channel.contactName;
        }

        if (this.selectedFieldsFilterCheck.includes('email')) {
          userFiltered.Email = channel.email;
        }

        if (this.selectedFieldsFilterCheck.includes('category')) {
          userFiltered['Channel Category'] = channel.category;
        }

        if (this.selectedFieldsFilterCheck.includes('group')) {
          if (channel.group === '' && channel.category === '') {
            userFiltered['Channel Group'] = 'All';
          } else {
            userFiltered['Channel Group'] = channel.group;
          }
        }

        if (this.selectedFieldsFilterCheck.includes('type')) {
          var channelType = channel.type;
          if (channel.isForceFollowing) {
            channelType = `${channelType}, FORCE FOLLOWING`;
          }

          userFiltered['Channel Type'] = channelType;
        }

        if (this.selectedFieldsFilterCheck.includes('accessCode')) {
          userFiltered['Access Code'] = channel.accessCode;
        }

        if (this.selectedFieldsFilterCheck.includes('usersCounts')) {
          userFiltered['Primary User Count'] = channel.userCount;
        }

        if (this.selectedFieldsFilterCheck.includes('usersCounts')) {
          userFiltered['Secondary User Count'] = channel.secondaryUserCount;
        }

        if (this.selectedFieldsFilterCheck.includes('usersCounts')) {
          userFiltered['Force Following User Count'] = channel.fcUserCount;
        }

        if (this.selectedFieldsFilterCheck.includes('dateCreated')) {
          userFiltered['Date Created'] = String(`${channel.dateCreatedYMD} ${channel.dateCreatedHMS}`) || '';
        }
        if (this.selectedFieldsFilterCheck.includes('sentSms')) {
          userFiltered['Last 30 Days Text Messages'] = channel.sentSms;
        }
        if (this.selectedFieldsFilterCheck.includes('accountId')) {
          const orgNumber = ('00' + String(this.$store.state.company.company.companyNumber)).slice(-3);
          const channelNumber = ('000000' + String(channel.channelNumber)).slice(-7);
          userFiltered['Account ID'] = `${orgNumber}-${channelNumber}`;
        }

        if (this.selectedFieldsFilterCheck.includes('resellerCode')) {
          userFiltered['Reseller Code'] = channel.resellerCode;
        }
        if (this.selectedFieldsFilterCheck.includes('partnerAccountNumber')) {
          userFiltered['Partner Account Number'] = channel.partnerAccountNumber;
        }
        if (this.selectedFieldsFilterCheck.includes('revenueCollectionMethod')) {
          userFiltered['Revenue Collection Method'] = channel.revenueCollectionMode;
        }
        if (this.selectedFieldsFilterCheck.includes('offAppTextCreditsUsedLastMonth')) {
          userFiltered['Off-App Text Credits Used - Last Month'] = channel.off_app_text_credits_used_last_month;
        }
        if (this.selectedFieldsFilterCheck.includes('offAppTextCreditsPurchasedLastMonth')) {
          userFiltered['Off-App text credits purchased - Last month'] = channel.purchased_off_app_text_credits_last_month;
        }
        if (this.selectedFieldsFilterCheck.includes('offAppTextCreditsUsedCurrentMonth')) {
          userFiltered['Off-App Text Credits Used - Current Month'] = channel.off_app_text_credits_used_current_month;
        }
        if (this.selectedFieldsFilterCheck.includes('secureVideoEnabled')) {
          userFiltered['Secure Video Enabled'] = channel.enablePrivateVideo;
        }
        if (this.selectedFieldsFilterCheck.includes('totalMessagesSentLastMonth')) {
          userFiltered['Total Messages Sent - Last Month'] = channel.total_messages_sent_last_month;
        }
        // fetch plan data
        let planName = '';
        let assocPricePlanMaxAppUsers = 0;
        let monthlyCost = 0;
        // if not data then price plans havent been loaded yet
        if (data) {
          for (let i = 0; i < data.length; i++) {
            if (data[i]._id === channel.pricePlan) {
              planName = data[i].plan_name;
              assocPricePlanMaxAppUsers = data[i].max_app_users;
              monthlyCost = data[i].montly_charge + channel.purchased_app_users_cost;
              break;
            }
          }
        }

        if (this.selectedFieldsFilterCheck.includes('registeredUserCount')) {
          userFiltered['Registered User Count'] = channel.registeredUserCount;
        }

        if (this.selectedFieldsFilterCheck.includes('monthlyCharge')) {
          userFiltered['Monthly Charge'] = '$' + monthlyCost.toFixed(2);
        }

        if (this.selectedFieldsFilterCheck.includes('pricePlanName')) {
          userFiltered['Price Plan Name'] = planName;
        }
        if (this.selectedFieldsFilterCheck.includes('maxAppUsers')) {
          userFiltered['Max App Users'] = channel.purchased_app_users + assocPricePlanMaxAppUsers;
        }
        if (this.selectedFieldsFilterCheck.includes('adminLoginsMonth')) {
          userFiltered['Admin Logins Month'] = channel.adminLoginsMonth;
        }
        if (this.selectedFieldsFilterCheck.includes('userLoginsMonth')) {
          userFiltered['User Logins Month'] = channel.userLoginsMonth;
        }
        if (this.selectedFieldsFilterCheck.includes('movConversionMs')) {
          userFiltered['MOV Conversion MS'] = channel.movConversionMs;
        }
        if (this.selectedFieldsFilterCheck.includes('audioViewCount')) {
          userFiltered['Audio File View Count'] = channel.audioViewCount;
        }
        if (this.selectedFieldsFilterCheck.includes('videoViewCount')) {
          userFiltered['Video File View Count'] = channel.videoViewCount;
        }
        if (this.selectedFieldsFilterCheck.includes('imageViewCount')) {
          userFiltered['Image View Count'] = channel.imageViewCount;
        }
        if (this.selectedFieldsFilterCheck.includes('fileViewCount')) {
          userFiltered['File View Count'] = channel.fileViewCount;
        }
        if (this.selectedFieldsFilterCheck.includes('audioViewDataTransferOut')) {
          userFiltered['Audio Data Transfer Out'] = channel.audioViewDataTransferOut;
        }
        if (this.selectedFieldsFilterCheck.includes('videoViewDataTransferOut')) {
          userFiltered['Video Data Transfer Out'] = channel.videoViewDataTransferOut;
        }
        if (this.selectedFieldsFilterCheck.includes('imageViewDataTransferOut')) {
          userFiltered['Image Data Transfer Out'] = channel.imageViewDataTransferOut;
        }
        if (this.selectedFieldsFilterCheck.includes('fileViewDataTransferOut')) {
          userFiltered['File Data Transfer Out'] = channel.fileViewDataTransferOut;
        }

        userFiltered.Status = channel.status.status;
        filteredList.push(userFiltered);
      });

      return filteredList;
    },
    loading() {
      return this.$store.state.contentProvider.loading;
    },
    contentProviderList: {
      get() {
        return this.contentProviderListFilter;
      },
      set(newList) {
        return newList;
      },
    },
    currentUserID: {
      get: function () {
        return this.$store.state.user.userID;
      },
      set: function (newValue) {
        return newValue;
      },
    },
    currentUserGroup() {
      return this.$store.state.user.userGroup || null;
    },
    selectedCompany: {
      get: function () {
        let selectedCompany = this.$store.state.company.selectedCompany || Cookies.get('companyID');
        return selectedCompany;
      },
      set: function (newValue) {
        return newValue;
      },
    },
    voboFrontendURL: {
      get: function () {
        return this.frontEndURL;
      },
    },
    defaultChannel() {
      return this.$store.state.contentProvider.defaultCompany;
    },
    cpEditLink: {
      get: function () {
        return (item, search) => {
          if (search && search !== '') {
            return `/content-provider/edit/${item}?q=${search}`;
          } else {
            return `/content-provider/edit/${item}`;
          }
        };
      },
      set: function (newValue, oldValue) {
        return newValue;
      },
    },
    fieldsFilter: {
      get: function () {
        return [
          { value: 'accountId', text: 'Account ID' },
          { value: 'pricePlanName', text: 'Price Plan Name' },
          { value: 'resellerCode', text: 'Reseller Code' },
          { value: 'partnerAccountNumber', text: 'Partner Account Number' },
          { value: 'revenueCollectionMethod', text: 'Revenue Collection Method' },
          { value: 'offAppTextCreditsUsedLastMonth', text: 'Off-App Text Credits Used - Last Month' },
          { value: 'offAppTextCreditsPurchasedLastMonth', text: 'Off-App text credits purchased - Last month' },
          { value: 'offAppTextCreditsUsedCurrentMonth', text: 'Off-App Text Credits Used - Current Month' },
          { value: 'secureVideoEnabled', text: 'Secure Video Enabled' },
          { value: 'totalMessagesSentLastMonth', text: 'Total Messages Sent - Last Month' },
          { value: 'maxAppUsers', text: 'Max App Users' },
          { value: 'partnerAccountNumber', text: 'Partner Account Number' },
          { value: 'clientName', text: 'Channel Name' },
          { value: 'contactName', text: 'Full Name' },
          { value: 'email', text: 'Email' },
          { value: 'category', text: 'Channel Category' },
          { value: 'group', text: 'Channel Group' },
          { value: 'type', text: 'Channel Type' },
          { value: 'accessCode', text: 'Access Code' },
          { value: 'usersCounts', text: 'User Count' },
          { value: 'dateCreated', text: 'Date Created' },
          { value: 'sentSms', text: 'Last 30 days txt messages' },
          { value: 'monthlyCharge', text: 'Monthly Charge' },
          { value: 'registeredUserCount', text: 'Registered User Count' },
          { value: 'adminLoginsMonth', text: 'Admin Logins Month' },
          { value: 'userLoginsMonth', text: 'User Logins Month' },
          { value: 'movConversionMs', text: 'MOV Conversion Minutes' },
          { value: 'audioViewCount', text: 'Audio File View Count' },
          { value: 'videoViewCount', text: 'Video File View Count' },
          { value: 'imageViewCount', text: 'Image View Count' },
          { value: 'fileViewCount', text: 'File View Count' },
          { value: 'audioViewDataTransferOut', text: 'Audio Data Transfer Out' },
          { value: 'videoViewDataTransferOut', text: 'Video Data Transfer Out' },
          { value: 'imageViewDataTransferOut', text: 'Image Data Transfer Out' },
          { value: 'fileViewDataTransferOut', text: 'File Data Transfer Out' },
        ];
      },
      set: function (newValue) {
        return newValue;
      },
    },
  },
  watch: {
    selectedStatus: function (context) {
      var cpCategories = this.$store.state.contentProvider.cpList[context];
      cpCategories = cpCategories.sort(function (a, b) {
        return new Date(b.dateCreated) - new Date(a.dateCreated);
      });
      this.contentProviderListFilter = cpCategories;
      this.totalRows = this.contentProviderListFilter.length;

      var cpList = this.contentProviderListFilter;
      this.CSVData = cpList;
    },
    totalRows: function (value) {
      let self = this;

      window.addEventListener('click', function (e) {
        if (e.target.classList.contains('downloadCSVButton')) {
          document.getElementById('fieldsFilter__BV_toggle_').click();
          self.selectedFieldsFilterCheck = [
            'clientName',
            'contactName',
            'email',
            'category',
            'group',
            'type',
            'accessCode',
            'usersCounts',
            'dateCreated',
            'sentSms',
            'accountId',
            'pricePlanName',
            'resellerCode',
            'partnerAccountNumber',
            'revenueCollectionMethod',
            'offAppTextCreditsUsedLastMonth',
            'offAppTextCreditsPurchasedLastMonth',
            'offAppTextCreditsUsedCurrentMonth',
            'secureVideoEnabled',
            'totalMessagesSentLastMonth',
            'maxAppUsers',
            'partnerAccountNumber',
            'monthlyCharge',
            'registeredUserCount',
            'adminLoginsMonth',
            'userLoginsMonth',
            'movConversionMs',
            'audioViewCount',
            'videoViewCount',
            'imageViewCount',
            'fileViewCount',
            'audioViewDataTransferOut',
            'videoViewDataTransferOut',
            'imageViewDataTransferOut',
            'fileViewDataTransferOut',
          ];
        }
      });
    },
  },
  mounted() {
    //HERE
    if (this.currentUserGroup == 4 || this.currentUserGroup == 1) {
      this.loadContentProviders(this.currentPage);
      this.loadSelectedCompany(this.$store.state.user.company._id);

      if (this.$route.query.q && this.$route.query.q !== '') {
        this.searchRequest = this.$route.query.q;
      }
    }
  },
  methods: {
    copyLink(select) {
      let linkToCopy = document.getElementById(select);
      linkToCopy.setAttribute('type', 'text');
      linkToCopy.select();

      try {
        var successful = document.execCommand('copy');

        var msg = successful ? 'successful' : 'unsuccessful';
        wrapNotification(this.$notify, NotificationTypes.Success, 'Invitation Url Copied to Clipboard');
      } catch (err) {
        wrapNotification(this.$notify, NotificationTypes.Error, 'There is an error copying invitation url');
      }

      linkToCopy.setAttribute('type', 'hidden');
      window.getSelection().removeAllRanges();
    },
    channelInviteModal(inviteID) {
      this.inviteID = inviteID;
    },
    closeInviteModal(e) {
      if (e.target.tagName === 'A' || e.srcElement.tagName === 'A' || e.target.tagName === 'I' || e.srcElement.tagName === 'I') {
        return;
      }
      this.inviteID = '';
    },
    duplicateCp(userid, clientName) {
      this.$swal
        .fire(DuplicateCpAlert(clientName))
        .then(async (result) => {
          if (!result) {
            return;
          }
          if (result.dismiss === 'cancel' || result.dismiss === 'close' || result.dismiss === 'esc' || result.dismiss === 'backdrop') {
            this.$swal.close();
            return;
          }

          const token = Cookies.get('user-token') || globalStore.token;
          let companyID = Cookies.get('companyID') || '';
          duplicateContentProvider(token, {
            userId: userid,
            clientName: result.value[0],
            contactName: result.value[1],
            contactEmail: result.value[2],
            companyID,
            password: result.value[3],
          })
            .then((res) => {
              this.loadContentProviders(this.currentPage);
              wrapNotification(this.$notify, NotificationTypes.Success, 'Created Replica Channel');
              this.$swal.close();
            })
            .catch((err) => {
              wrapNotification(this.$notify, NotificationTypes.Error, 'Error Creating Replica Channel');
              this.$swal.close();
            });
        })
        .catch((err) => {
          this.$swal(JSON.stringify(err));
        });
    },
    openCPForm() {
      let companyID = Cookies.get('companyID') || '';
      if (!companyID || companyID === '') {
        this.$swal
          .fire({
            type: 'warning',
            position: 'center',
            imageWidth: 150,
            title: 'Organization is Required',
            html: 'Please select organization from the dropdown first located in upper left of the screen in order to create content providers',
            showConfirmButton: true,
            showCancelButton: false,
            confirmButtonText: 'Ok',
            confirmButtonClass: 'btn btn-primary pr-5 pl-5',
            footer: '<div class="text-center"> </div>',
            buttonsStyling: false,
            allowOutsideClick: false,
          })
          .then((result) => {});
      } else {
        this.$router.push('/content-provider/create');
      }
    },
    async loadContentProviders(currentPage) {
      const companyID = this.selectedCompany;
      if (companyID) {
        this.$store.dispatch('contentProvider/GET_CONTENT_PROVIDERS', companyID).then((resp) => {
          var filter = 'all';
          var cpCategories = this.$store.state.contentProvider.cpList[filter];

          cpCategories = cpCategories.sort(function (a, b) {
            return new Date(b.dateCreated) - new Date(a.dateCreated);
          });

          this.contentProviderListFilter = cpCategories;
          this.totalRows = this.contentProviderListFilter.length;
          this.totalActiveRows = this.$store.state.contentProvider.cpList.active.length;

          var channelList = this.contentProviderListFilter;
          this.CSVData = channelList;
        });

        const token = Cookies.get('user-token') || globalStore.token;
        const { data } = await getPricePlanList(token, companyID);
        this.pricePlanList = data;
      }
    },
    onSearch(filteredItems) {
      this.$nextTick(() => {
        this.errorFields = [];
        this.totalRows = filteredItems.length;
        this.currentPage = 1;
        this.selectedFieldsFilterCheck = [
          'clientName',
          'contactName',
          'email',
          'category',
          'group',
          'type',
          'accessCode',
          'usersCounts',
          'dateCreated',
          'sentSms',
          'accountId',
          'pricePlanName',
          'resellerCode',
          'partnerAccountNumber',
          'revenueCollectionMethod',
          'offAppTextCreditsUsedLastMonth',
          'offAppTextCreditsPurchasedLastMonth',
          'offAppTextCreditsUsedCurrentMonth',
          'secureVideoEnabled',
          'totalMessagesSentLastMonth',
          'maxAppUsers',
          'partnerAccountNumber',
          'monthlyCharge',
          'registeredUserCount',
          'adminLoginsMonth',
          'userLoginsMonth',

          'movConversionMs',
          'audioViewCount',
          'videoViewCount',
          'imageViewCount',
          'fileViewCount',
          'audioViewDataTransferOut',
          'videoViewDataTransferOut',
          'imageViewDataTransferOut',
          'fileViewDataTransferOut',
        ];
        this.CSVData = filteredItems;
      });
    },
    updateCurrentPage(currentPage) {
      this.errorFields = [];
      this.currentPage = currentPage;
    },
    loadInitialPendingVisibleItems() {
      this.$nextTick(() => {
        // this.getPendingVisibleItems()
      });
    },
    deleteProcess(id, item) {
      const contentProviderID = String(id).trim();
      var itemString = `<strong>${item.clientName}</strong>?`;
      var htmlCustom = `<div class="swal2-icon swal2-question" style="display:flex"></div>This channel has <strong>${item.userCount}</strong> active primary users, if you continue they will be re-registered with the organization default channel. <br/><br/>`;

      if (Object.keys(this.defaultChannel).length === 0) {
        this.$swal
          .fire({
            position: 'center',
            html: '<div class="py-3">Please create a default channel first before deleting this channel</div>',
            showConfirmButton: true,
            showCancelButton: false,
            confirmButtonText: 'Create Default Channel',
            confirmButtonClass: 'btn btn-primary pr-5 pl-5',
            showLoaderOnConfirm: true,
            buttonsStyling: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
          })
          .then((result) => {
            if (result.value) {
              this.$router.push('/content-provider/create');
            }
          });
      } else {
        if (item.userCount > 0) {
          this.showConfirmation(this.deleteContentProvider, contentProviderID, itemString, '', true, htmlCustom, true);
        } else {
          itemString = `<strong>${item.clientName}</strong>`;
          this.showConfirmation(this.deleteContentProvider, contentProviderID, itemString);
        }
      }
    },
    deleteContentProvider(contentProviderID) {
      this.$store
        .dispatch('contentProvider/DELETE_CONTENT_PROVIDER', contentProviderID)
        .then((res) => {
          if (res.data.success) {
            wrapNotification(this.$notify, NotificationTypes.Success, 'Content provider user successfully deleted');
            this.loadContentProviders(this.currentPage);
          } else {
            wrapNotification(this.$notify, NotificationTypes.Error, 'Error deleting content provider');
          }
        })
        .catch((err) => {
          console.error(err);
          err.then((error) => {
            wrapNotification(this.$notify, NotificationTypes.Error, error.errMessage);
            this.hasError = true;
          });
        });
    },
    resetPassword(id) {
      const userID = String(id).trim();
      this.$store
        .dispatch('user/RESET_PASSWORD_REQUEST', userID)
        .then((res) => {
          if (res.data.success) {
            wrapNotification(this.$notify, NotificationTypes.Success, 'Email sent to user to reset the password');
          } else {
            wrapNotification(this.$notify, NotificationTypes.Error, 'Error resetting user password');
          }
        })
        .catch((err) => {
          console.error(err);
          err.then((error) => {
            wrapNotification(this.$notify, NotificationTypes.Error, error.errMessage);
            this.hasError = true;
          });
        });
    },
    loadSelectedCompany() {
      this.$store.dispatch('company/GET_COMPANY_LIST').then((resp) => {
        var companyID = Cookies.get('companyID');
        let company = resp.filter((companyVal) => {
          return companyVal.companyID === companyID;
        });

        this.$store.commit('company/SET_SELECTED_COMPANY', companyID);
        this.$store.commit('company/SET_SELECTED_COMPANY_DETAILS', company[0]);
        this.$root.$store.state.user.companyID = companyID;

        let companyStore = this.$store.state.company.company;
        let faviconIcon = '/favicon.ico';

        if (companyStore === null || companyStore === '' || companyStore === undefined) {
          faviconIcon = '/favicon.ico';
        } else {
          faviconIcon = companyStore.favicon + '?=' + Math.random() || companyStore.logo + '?=' + Math.random();
        }

        var favicon = document.querySelectorAll('.favicon');
        for (var i = 0; i < favicon.length; i++) {
          favicon[i].href = faviconIcon;
        }

        document.title = companyStore ? companyStore.name : 'Vobo';
      });
    },
    activateContentProvider(currentStatus, id, userID) {
      let isActive = 0;
      let statusValue = '';

      if (currentStatus === 'active') {
        isActive = 0;
        statusValue = 'Deactivated';
      } else {
        isActive = 1;
        statusValue = 'Activated';
      }

      const formData = { isActive };
      const contentProviderID = String(id).trim();

      this.$store
        .dispatch('contentProvider/UPDATE_CONTENT_PROVIDER_STATUS', {
          formData,
          contentProviderID,
        })
        .then((res) => {
          if (res.data.success) {
            wrapNotification(this.$notify, NotificationTypes.Success, 'Content provider successfully ' + statusValue);
            this.loadContentProviders(this.currentPage);
          } else {
            wrapNotification(this.$notify, NotificationTypes.Error, 'Error updating content provider status');
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    updateFilteredFields(field) {
      var index = this.selectedFieldsFilter.indexOf(field);

      if (index > -1) {
        this.selectedFieldsFilter.splice(index, 1);
      } else {
        this.selectedFieldsFilter.push(field);
      }
    },
  },
};
</script>
<style lang="scss">
.table .thead-light .hdcolor {
  color: #536c79 !important;
}
.is-invalid {
  border-color: red !important;
  color: red !important;
}
.transaction-error {
  font-size: 0.68rem;
}

a.btn-outline-danger:hover,
a.btn-outline-vobo:hover,
a.btn-outline-default:hover,
a.btn-outline-primary:hover,
a.btn-outline-success:hover {
  color: #fff !important;
}

.cpTable td .userBtn a,
.cpTable td .userBtn button,
.cpTable td .userBtn a,
.cpTable td .userBtn button {
  margin-right: 0.25rem !important;
  width: 34px !important;
  height: 30px !important;
}

.cpTable .data .title {
  font-size: 0.8rem !important;
}

.cpTable td a {
  margin-right: 0.25rem !important;
}

.cpTable td a:last-child {
  margin-right: 0 !important;
}

.cpTable .table td {
  padding: 0.6rem;
}

.cpTable tr {
  th {
    text-align: center;
  }

  &:focus {
    outline: 0 !important;
    outline: none !important;
  }
}

.cpTable tr th:first-child,
.cpTable tr td:first-child {
  width: 20% !important;
}

.cpTable tr th:nth-child(2),
.cpTable tr td:nth-child(2) {
  width: 20% !important;
}

.cpTable tr th:nth-child(3),
.cpTable tr td:nth-child(3) {
  width: 15% !important;
}

.cpTable tr th:nth-child(4),
.cpTable tr td:nth-child(4) {
  width: 10% !important;
}

.cpTable tr th:nth-child(5),
.cpTable tr td:nth-child(5) {
  width: 10% !important;
}

.cpTable tr th:nth-child(6),
.cpTable tr td:nth-child(6) {
  width: 10% !important;
}

.cpTable tr th:nth-child(7),
.cpTable tr td:nth-child(7) {
  width: 20% !important;
}

.cpTable tr td:nth-child(5),
.cpTable tr td:nth-child(4) {
  text-align: center;
}

.target-fade-cancel {
  -webkit-animation: target-fade-cancel 2s 1;
  -moz-animation: target-fade-cancel 2s 1;
}

@-webkit-keyframes target-fade-cancel {
  0% {
    background-color: rgba(248, 108, 107, 0.3);
  }

  100% {
    background-color: rgba(248, 108, 107, 0);
  }
}

@-moz-keyframes target-fade-cancel {
  0% {
    background-color: rgba(248, 108, 107, 0.3);
  }

  100% {
    background-color: rgba(248, 108, 107, 0);
  }
}

.target-fade-complete {
  -webkit-animation: target-fade-complete 2s 1;
  -moz-animation: target-fade-complete 2s 1;
}

@-webkit-keyframes target-fade-complete {
  0% {
    background-color: rgba(77, 189, 116, 0.3);
  }

  100% {
    background-color: rgba(77, 189, 116, 0);
  }
}

@-moz-keyframes target-fade-complete {
  0% {
    background-color: rgba(77, 189, 116, 0.3);
  }

  100% {
    background-color: rgba(77, 189, 116, 0);
  }
}

.cpTable .text-break-all {
  word-break: break-word !important;
  white-space: inherit !important;
}

.catgroup {
  width: 100% !important;
  font-size: 10px;
  font-weight: bold;
  float: left;
}

.ffbadge {
  margin-top: 4px;
}

#fieldsFilter {
  ul {
    width: 460px;
    padding: 15px;

    li {
      width: 100%;
      float: left;

      .form-group {
        width: 100%;

        div.custom-control.custom-control-inline.custom-checkbox {
          width: 50%;
          float: left;
          padding-right: 0 !important;
          margin-right: 0 !important;
        }
      }
    }
  }

  .dropdown-toggle::after {
    display: inline-block;
    margin-left: 0.255em;
    vertical-align: 0.255em;
    content: '';
    border-top: 0.3em solid;
    border-right: 0.3em solid transparent;
    border-bottom: 0;
    border-left: 0.3em solid transparent;
  }

  .dropdown-toggle::before {
    display: none !important;
  }

  .custom-control-label {
    height: auto;
  }
}

.userInfoRow {
  font-size: 13px;
  border-top: 1px solid #dee2e6 !important;
}

progress[value]::-webkit-progress-bar {
  border-radius: 40px;
}

progress[value]::-webkit-progress-value {
  border-radius: 40px;
}
</style>
